import { Text } from "@amzn/storm-ui";

import SkeletonLoader from "../../../common/SkeletonLoader";
import { DivJustifyItemCenter } from "../../../common/styled.components";

import {
    StyledDetailSheetTitleContainer,
    StyledDetailSheetDetailsContainer,
} from "./styles";

export const PdfContainerSkeletonLoader = (): JSX.Element => {
    return (
        <div data-testid="pdf-container-skeleton-loader">
            <SkeletonLoader height="200px" />
            <SkeletonLoader height="200px" />
            <SkeletonLoader height="200px" />
        </div>
    );
};

export const HeaderSkeletonLoader = (): JSX.Element => {
    return (
        <div data-testid="header-skeleton-loader">
            <SkeletonLoader width="200px" />
            <StyledDetailSheetTitleContainer>
                <SkeletonLoader height="40px" />
            </StyledDetailSheetTitleContainer>
            <StyledDetailSheetDetailsContainer>
                <SkeletonLoader height="100px" />
            </StyledDetailSheetDetailsContainer>
        </div>
    );
};

export const FooterSkeletonLoader = (): JSX.Element => {
    return <SkeletonLoader height="40px" />;
};

export const PdfContainerSkeletonGenerationLoader = (): JSX.Element => {
    return (
        <div data-testid="pdf-container-skeleton-generation-loader">
            <SkeletonLoader
                loadingText={
                    <DivJustifyItemCenter>
                        <Text>
                            Generating Preview...
                            <br />
                            You can view the insights offline by using the
                            Download button below.
                        </Text>
                    </DivJustifyItemCenter>
                }
                height="600px"
            />
        </div>
    );
};
